import React from "react";
import Text from "../../../common/typography/text";
import ProfileProviderIcon from "../../../icons/provider-profile-icon";
import Tags from "../../../common/tags";

const joinTextParts = (parts = [], separator = ", ") =>
  parts
    .map((part) => (typeof part === "string" ? part.trim() : part))
    .filter(Boolean)
    .join(separator);

const formatCityStateZip = (accountDetails) => {
  const location = joinTextParts(
    [accountDetails?.City, accountDetails?.State],
    ", ",
  );

  return joinTextParts([location, accountDetails?.Zip], " ");
};

const formatAddressLines = (accountDetails) => {
  const firstLine = joinTextParts(
    [accountDetails?.AddressLine1],
    ", ",
  );
  const secondLine = joinTextParts(
    [accountDetails?.AddressLine2, formatCityStateZip(accountDetails)],
    ", ",
  );

  if (firstLine) {
    return {
      firstLine,
      secondLine,
    };
  }

  return {
    firstLine: secondLine,
    secondLine: "",
  };
};

const getAssignedSalesRepName = (accountDetails) => {
  if (!accountDetails?.IsDistUserAssigned) {
    return "";
  }

  return joinTextParts([accountDetails?.DistributorUsername], " ");
};

const getContactName = (contact) =>
  typeof contact === "string" ? contact.trim() : contact?.label || "";

const ShippingReview = ({
  accountName,
  shipToAccountName,
  shipToAccountDetails,
  billToAccountDetails,
  shippingContact,
  shippingContactTagText,
  isPhone,
}) => {
  const shipToAddress = formatAddressLines(shipToAccountDetails);
  const billToAddress = formatAddressLines(billToAccountDetails);
  const assignedSalesRepName = getAssignedSalesRepName(shipToAccountDetails);
  const shippingContactName = getContactName(shippingContact);
  const shippingDetails = [
    {
      ShipTo: shipToAccountName || accountName,
      ShipAddress1: shipToAddress.firstLine,
      ShipAddress2: shipToAddress.secondLine,
      Contact: shippingContactName,
      Phone: shipToAccountDetails?.Phone || "",
      Fax: shipToAccountDetails?.Fax || "",
      BillTo: billToAccountDetails?.AccountName || accountName,
      BillAddress1: billToAddress.firstLine,
      BillAddress2: billToAddress.secondLine,
      APContact: billToAccountDetails?.APContact || "",
      APPhone: billToAccountDetails?.Phone || "",
      APFax: billToAccountDetails?.Fax || "",
      DistributorID:
        shipToAccountDetails?.DistributorID != null
          ? Number(shipToAccountDetails.DistributorID)
          : null,
      DistributorName: shipToAccountDetails?.DistributorName || "",
      SalesRep: assignedSalesRepName,
    },
  ];

  return (
    <>
      <Text variant="h1">Shipping Summary</Text>
      {shippingDetails.length > 0 && (
        <div className="direct-order-review-detail-container">
          {shippingDetails?.map((shipping) => {
            return (
              <>
                <div className="direct-order-review-detail-child-container">
                  <div className="direct-order-review-detail-text-container">
                    <div className="direct-order-review-detail-title-text-container">
                      <Text variant="bodyText" color="lightText">
                        Ship to
                      </Text>
                    </div>
                    <div className="direct-order-review-detail-content-text-container">
                      <Text variant="bodyTextBold">{shipping.ShipTo}</Text>
                      {shipping.ShipAddress1 ? (
                        <div className="direct-order-review-detail-content-address-container">
                          <Text variant="bodyText">{shipping.ShipAddress1}</Text>
                        </div>
                      ) : null}
                      {shipping.ShipAddress2 ? (
                        <div className="direct-order-review-detail-content-address-container">
                          <Text variant="bodyText">{shipping.ShipAddress2}</Text>
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="direct-order-review-detail-text-container">
                    <div className="direct-order-review-detail-title-text-container">
                      <Text variant="bodyText" color="lightText">
                        Contact
                      </Text>
                    </div>
                    {shipping.Contact ? (
                      <div className="direct-order-review-detail-content-text-container">
                        <div
                          className="direct-order-review-detail-content-code-quality-container"
                          style={isPhone ? { flexDirection: "column" } : {}}
                        >
                          <ProfileProviderIcon className="icon-container-lightText" />
                          <Text variant="bodyText" color="lightText">
                            {shipping.Contact}
                          </Text>
                          {shippingContactTagText ? (
                            <Tags
                              tagText={shippingContactTagText}
                              tagBackground="blueBackground"
                              textColor="primaryColor"
                            />
                          ) : null}
                        </div>
                      </div>
                    ) : null}
                  </div>
                  <div className="direct-order-review-detail-text-container">
                    <div className="direct-order-review-detail-title-text-container">
                      <Text variant="bodyText" color="lightText">
                        Phone
                      </Text>
                    </div>
                    <div className="direct-order-review-detail-content-text-container">
                      {shipping.Phone ? (
                        <Text variant="bodyText" color="lightText">
                          {shipping.Phone}
                        </Text>
                      ) : null}
                    </div>
                  </div>
                  <div className="direct-order-review-detail-text-container">
                    <div className="direct-order-review-detail-title-text-container">
                      <Text variant="bodyText" color="lightText">
                        Fax
                      </Text>
                    </div>
                    <div className="direct-order-review-detail-content-text-container">
                      {shipping.Fax ? (
                        <Text variant="bodyText" color="lightText">
                          {shipping.Fax}
                        </Text>
                      ) : null}
                    </div>
                  </div>
                </div>
                <div className="direct-order-review-detail-child-container">
                  <div className="direct-order-review-detail-text-container">
                    <div className="direct-order-review-detail-title-text-container">
                      <Text variant="bodyText" color="lightText">
                        Bill to
                      </Text>
                    </div>
                    <div className="direct-order-review-detail-content-text-container">
                      <Text variant="bodyTextBold">{shipping.BillTo}</Text>
                      <div className="direct-order-review-detail-content-address-container">
                        <Text variant="bodyText">{shipping.BillAddress1}</Text>
                      </div>
                      <div className="direct-order-review-detail-content-address-container">
                        <Text variant="bodyText">{shipping.BillAddress2}</Text>
                      </div>
                    </div>
                  </div>
                  <div className="direct-order-review-detail-text-container">
                    <div className="direct-order-review-detail-title-text-container">
                      <Text variant="bodyText" color="lightText">
                        Contact
                      </Text>
                    </div>
                    <div className="direct-order-review-detail-content-text-container">
                      {shipping.APContact ? (
                        <div
                          className="direct-order-review-detail-content-code-quality-container"
                          style={isPhone ? { flexDirection: "column" } : {}}
                        >
                          <ProfileProviderIcon className="icon-container-lightText" />
                          <Text variant="bodyText" color="lightText">
                            {shipping.APContact}
                          </Text>
                        </div>
                      ) : (
                        <Text variant="bodyText" color="lightText">
                          -
                        </Text>
                      )}
                    </div>
                  </div>
                  <div className="direct-order-review-detail-text-container">
                    <div className="direct-order-review-detail-title-text-container">
                      <Text variant="bodyText" color="lightText">
                        Phone
                      </Text>
                    </div>
                    <div className="direct-order-review-detail-content-text-container">
                      {shipping.APPhone ? (
                        <Text variant="bodyText" color="lightText">
                          {shipping.APPhone}
                        </Text>
                      ) : (
                        <Text variant="bodyText" color="lightText">
                          -
                        </Text>
                      )}
                    </div>
                  </div>
                  <div className="direct-order-review-detail-text-container">
                    <div className="direct-order-review-detail-title-text-container">
                      <Text variant="bodyText" color="lightText">
                        Fax
                      </Text>
                    </div>
                    <div className="direct-order-review-detail-content-text-container">
                      {shipping.APFax ? (
                        <Text variant="bodyText" color="lightText">
                          {shipping.APFax}
                        </Text>
                      ) : (
                        <Text variant="bodyText" color="lightText">
                          -
                        </Text>
                      )}
                    </div>
                  </div>
                </div>
              </>
            );
          })}
        </div>
      )}
      <div className="direct-order-review-detail-container">
        <div className="direct-order-review-detail-child-container">
          <div className="direct-order-review-detail-text-container">
            <div className="direct-order-review-detail-title-text-container">
              <Text variant="bodyText" color="lightText">
                Distributor
              </Text>
            </div>
            <div className="direct-order-review-detail-content-text-container">
              {shippingDetails[0]?.DistributorName ? (
                <Text variant="bodyTextBold">
                  {shippingDetails[0].DistributorName}
                </Text>
              ) : null}
            </div>
          </div>
          <div className="direct-order-review-detail-text-container">
            <div className="direct-order-review-detail-title-text-container">
              <Text variant="bodyText" color="lightText">
                Sales Rep
              </Text>
            </div>
            <div className="direct-order-review-detail-content-text-container">
              {shippingDetails[0]?.SalesRep ? (
                <div className="direct-order-review-detail-content-code-quality-container">
                  <ProfileProviderIcon className="icon-container-lightText" />
                  <Text variant="bodyText" color="lightText">
                    {shippingDetails[0].SalesRep}
                  </Text>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ShippingReview;
